/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Widget Configurator Sample
	 * The input and output of the configurator is the profile of its corressponding
	 * widget.
	 * @author zyz
	 * @created 03/22/2016
	 */
	
	__webpack_require__(2);
	
	var activator = {
	    init: function init() {},
	
	    /**
	     * @setProfile {Function} [required] Will be called when user decides to
	     * config the widget on workbench.
	     * @param {Object} profile The profile of corresponding widget.
	     */
	    setProfile: function setProfile(profile) {
	        if (!profile) {
	            return;
	        }
	    },
	    /**
	     * @getProfile {Function} [required] Will be called when user click the save
	     * button which is on the bottom of the configurator dialog.
	     * @return {Object} profile
	     */
	    getProfile: function getProfile() {
	        return {
	            name: 'tj'
	        };
	    },
	    /**
	     * @isProfileOK {Function} [optional] This function is responsible for
	     * checking the validation of the widget profile, and giving the tips
	     * to user via various message box and return false if the profile is
	     * invalid. This method will be called when user click the save button
	     * of the configurator dialog before calling the method of [getProfile]
	     * . Note that no validation process before saving profile if this method
	     * is not implemented.
	     * @return {Boolean}
	     */
	    isProfileOK: function isProfileOK() {
	        if (true) {
	            alert('activator.isProfileOK method is called and true is returned');
	            return true;
	        } else {
	            alert('You should set ... so that..');
	            return false;
	        }
	    },
	
	    /**
	     * @getSupportedEventList {Function} [optional] This method will be called if
	     * implemented when the user click the save button to gather the events which
	     * will be triggered in runtime by the widget instance. Note that the supported
	     * events would be different with the different profiles configurated by user in
	     * the same type widget.
	     * @return {Array<Object>} EventList
	     */
	    getSupportedEventList: function getSupportedEventList() {
	        // TODO: Add your code here to return different event list following
	        // current configurated profile.
	
	        // Event list example
	        return [{
	            // Event Id [required]
	            id: "onselectrow",
	            // Event Name [required] Maybe you can set it as the same as the id.
	            name: "On Select Row",
	            // Event Description [optional]
	            // Maybe a i18n is needed to describe the event in variables languages.
	            des: "Triggered when user select a row"
	        }, {
	            id: "ondblclickrow",
	            name: "On DbClick Row",
	            des: "Triggered when user double click the row"
	        }, {
	            //...
	        }];
	    },
	    /**
	     * @getSupportedVariableList {Function} [optional] This method will be called if
	     * implemented when the user click the save button, to gather the variables owned
	     * by the widget instance. Note that the supported variables would be different with
	     * the different profiles configurated by user in the same type widget.
	     * @return {Array<Object>} VariableList
	     **/
	    getSupportedVariableList: function getSupportedVariableList() {
	
	        // TODO: Add your code here to return different variable list following
	        // current configurated profile.
	
	        // Variable list example
	        return [{
	            // Variable name [required]
	            name: 'rowid',
	            // Variable type [optional default string]
	            type: 'string',
	            // Variable description
	            des: 'Current selected row id.'
	        }, {
	            name: 'price',
	            type: 'number',
	            des: 'The money the user input currently'
	        }, {
	            // ...
	        }];
	    },
	    /**
	     * @getDependentVariableList {Function} [optional] This method is repsonsible
	     * for gathering the dependent variables of the widget from context.
	     * @return {Array<String>}
	     */
	    getDependentVariableList: function getDependentVariableList() {
	        // Variable List example
	        return ['1-userid', '11-curr_user_name'];
	    },
	    /**
	     * @getWidth {Function} [optional] Get the width of the widget following
	     * current configurated widget so that the width of window wrapper can be
	     * auto adapted. If not implemented, your widget should adapter automatically
	     * the width of outer window.
	     * @return {Number}
	     */
	    getWidth: function getWidth() {},
	
	    /**
	     * @getHeight {Function} [optional] Get the Height of the widget following
	     * current configurated widget so that the Height of window wrapper can be
	     * auto adapted. If not implemented, your widget should adapter automatically
	     * the Height of outer window.
	     * @return {Number}
	     */
	    getHeight: function getHeight() {}
	
	    // Considering...
	    // /**
	    //  * [getDependentDatasourceList description]
	    //  * @return {[type]} [description]
	    //  */
	    // getDependentDatasourceList: function() {},
	    // /**
	    //  * [getDependentProcedureList description]
	    //  * @return {[type]} [description]
	    //  */
	    // getDependentProcedureList: function() {},
	};
	
	// Excute after dom ready.
	$(function () {
	
	    // Init dom
	    activator.init();
	
	    // Export to window so that the father window can access this activator.
	    window.activator = activator;
	});

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(3);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!./../node_modules/css-loader/index.js?sourceMap!./../node_modules/less-loader/index.js!./index.less", function() {
			var newContent = require("!!./../node_modules/css-loader/index.js?sourceMap!./../node_modules/less-loader/index.js!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	exports.push([module.id, "body,html{height:100%}:focus{outline:0}body{font-size:62.5%;font-family:'Segoe UI',Tahoma,sans-serif;margin:0;padding:0;position:relative}.highlight{border:8px solid #00BFEF;color:#00BFEF}.config-container{padding:20px}#sqlEditor{height:150px}.main-editor .sql_editor{width:70%;display:inline-block;vertical-align:top}.main-editor .settings{width:30%;vertical-align:top;display:inline-block}", ""]);

/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	// 
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(var i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(JSON.stringify(sourceMap)) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// index.js